<div class="mcp-settings-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_MCP.DESCRIPTION' | translate }}
    </p>

    @if (initialLoadFailed() && loadError(); as error) {
      <tf-settings-load-error
        [title]="error.text"
        [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
        [details]="loadErrorDetails()"
        [retrying]="isLoading()"
        (retry)="retryLoad()" />
    } @else if (!hasLoadedOnce()) {
      <div class="mcp-loading-skeleton" aria-hidden="true">
        <section class="mcp-loading-skeleton__card">
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--title"></span>
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--text"></span>
          <div class="mcp-loading-skeleton__url-row">
            <span class="mcp-loading-skeleton__token"></span>
            <span class="mcp-loading-skeleton__icon"></span>
          </div>
        </section>

        <section class="mcp-loading-skeleton__card">
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--title"></span>
          <span class="mcp-loading-skeleton__control"></span>
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--text"></span>
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--text-short"></span>
          <span class="mcp-loading-skeleton__bar mcp-loading-skeleton__bar--text-shorter"></span>
        </section>
      </div>
    } @else {
      <tf-settings-inline-message
        [message]="saveError()"
        messageId="mcp-settings-save-error"
        (dismissed)="clearSaveError()" />

      @if (settings()?.mcpUrl) {
        <div class="settings-page__field">
          <span class="settings-page__label">{{ 'SETTINGS_MCP.MCP_URL' | translate }}</span>
          <div class="mcp-url-display">
            <code class="mcp-url-code">{{ settings()!.mcpUrl }}</code>
            <p-button
              icon="pi pi-copy"
              [text]="true"
              severity="secondary"
              [cdkCopyToClipboard]="settings()!.mcpUrl"
              (cdkCopyToClipboardCopied)="onUrlCopied()"
              [pTooltip]="
                (urlCopied() ? 'SETTINGS_MCP.URL_COPIED' : 'SETTINGS_MCP.COPY_URL') | translate
              "
              tooltipPosition="top" />
          </div>
        </div>
      }

      <div class="settings-page__field">
        <label for="mcp-mode" class="settings-page__label">
          {{ 'SETTINGS_MCP.MODE_LABEL' | translate }}
        </label>
        <div class="settings-page__field-input-wrap">
          <p-select
            inputId="mcp-mode"
            [options]="modeOptions()"
            [ngModel]="selectedMode()"
            (ngModelChange)="onModeChange($event)"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full"
            [disabled]="!settings()"
            [attr.aria-describedby]="saveError() ? 'mcp-settings-save-error' : null" />
        </div>
        <p class="settings-page__description mcp-mode-help-intro">
          {{ 'SETTINGS_MCP.MODE_HELP_INTRO' | translate }}
        </p>
        <ul class="mcp-mode-help-list">
          <li>{{ 'SETTINGS_MCP.MODE_HELP_READ_WRITE' | translate }}</li>
          <li>{{ 'SETTINGS_MCP.MODE_HELP_READ_ONLY' | translate }}</li>
          <li>{{ 'SETTINGS_MCP.MODE_HELP_OFF' | translate }}</li>
        </ul>
      </div>
    }
  </div>

  @if (hasLoadedOnce() && !initialLoadFailed()) {
    <tf-settings-actions
      (cancelled)="cancel()"
      (save)="save()"
      [disabled]="isLoading() || isSaving() || !settings()"
      [loading]="isSaving()" />
  }
</div>
